var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',{staticClass:"text-center mt-10"},[_c('v-col',[_c('v-btn',{attrs:{"x-large":"","dark":"","color":"#1db954"},on:{"click":_vm.signIn}},[_vm._v(" Sign In with Spotify ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }